import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../styles/TaskDetails.module.css';

interface BreadcrumbNavigationProps {
  groupId: string | null;
  groupName?: string | null;
  activeTab: string;
  isTemplate: boolean;
}

const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({
  groupId,
  groupName,
  activeTab,
  isTemplate
}) => {
  const navigate = useNavigate();

  const getTabLabel = () => {
    if (activeTab === 'details') return isTemplate ? 'Template Details' : 'Task Details';
    if (activeTab === 'submissions') return 'Submissions';
    if (activeTab === 'updates') return 'Task Updates';
    if (activeTab === 'instances') return 'Instances';
    return 'Task Details';
  };

  return (
    <div className={styles.groupHeader}>
      <nav className={styles.breadcrumbNav}>
        <div className={styles.navPath}>
          {groupId ? (
            <>
              <button 
                className={styles.navLink}
                onClick={() => navigate('/group-management')}
              >
                Group Management
              </button>
              <span className={styles.navSeparator}>/</span>
              {groupName ? (
                <button 
                  className={styles.navLink}
                  onClick={() => navigate(`/group-management/groups/${groupId}/task-management`)}
                >
                  {groupName}
                </button>
              ) : (
                <span className={styles.navLink}>Global Tasks</span>
              )}
              <span className={styles.navSeparator}>/</span>
              <span className={styles.navCurrent}>
                {getTabLabel()}
              </span>
            </>
          ) : (
            <>
              <button 
                className={styles.navLink}
                onClick={() => navigate('/task-management')}
              >
                Task Management
              </button>
              <span className={styles.navSeparator}>/</span>
              <span className={styles.navCurrent}>
                {getTabLabel()}
              </span>
            </>
          )}
        </div>
      </nav>
    </div>
  );
};

export default BreadcrumbNavigation;

